import {
  access,
  readFile as fsReadFile,
  writeFile as fsWriteFile,
  mkdir,
  rm,
} from 'node:fs/promises';
import { EOL } from 'node:os';
import { dirname } from 'node:path';
import process from 'node:process';
import { fileURLToPath } from 'node:url';

const isWindows = process.platform === 'win32';

export async function clearDir(dir: string): Promise<void> {
  await rm(dir, { recursive: true });
  await mkdir(dir);
}

/**
 * Normalizes a file path (either an absolute string or a file URL) to be
 * compatible with the current OS (windows and linux).
 */
export function normalizePath(id: string | URL): string {
  const filePath = typeof id === 'string' ? id : fileURLToPath(id);
  return isWindows ? slash(filePath) : filePath;
}

export async function outputDir(dir: string): Promise<void> {
  await mkdir(dir, { recursive: true });
}

export async function pathExists(path: string): Promise<boolean> {
  return access(path)
    .then(() => true)
    .catch(() => false);
}

export async function readJson(file: string): Promise<unknown> {
  return JSON.parse(await fsReadFile(file, 'utf-8'));
}

export function toJsonString(object: unknown, opts?: { spaces: number }) {
  return `${JSON.stringify(object, null, opts?.spaces)}${EOL}`;
}

export async function writeFile(filePath: string, str: string): Promise<void> {
  await outputDir(dirname(filePath));
  await fsWriteFile(filePath, str, 'utf-8');
}

export async function writeJson(
  filePath: string,
  object: unknown,
  opts: { spaces: number } = { spaces: 2 }
): Promise<void> {
  await writeFile(filePath, toJsonString(object, opts));
}

function slash(path: string) {
  return path.replaceAll('\\', '/');
}
